import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../../../shared/components/form/Form";
import { useForm } from "react-hook-form";
import { Button } from "../../../../shared/components/button/Button";
import { SymbolIcon } from "@radix-ui/react-icons";
import { Input } from "../../../../shared/components/input/Input";
import useToastWrapper from "../../../../hooks/useToastWrapper";

const ForgotPasswordForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToastWrapper();

  const validationSchema = yup.object({
    email: yup.string().required("El correo electrónico es obligatorio"),
  });

  const form = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { email: "" },
  });

  const onSubmitHandler = async (values) => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/passwords/forgot`, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then(async (response) => {
        if (response.ok) {
          toast.success(
            `Se ha enviado un email a la dirección ${values.email} con las instrucciones para restaurar su contraseña.`,
          );
        } else {
          const jsonResponse = await response.json();
          const message = jsonResponse.message;
          throw new Error(message);
        }
      })
      .catch((e) => {
        toast.error(`Error solicitando restauración de contraseña: ${e}`);
        console.log(`Error fetched: ${e}`);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmitHandler)}
        className="w-full px-5"
      >
        <div className="flex flex-col justify-center gap-y-2">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    placeholder="Correo electrónico"
                    {...field}
                    disabled={isLoading}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex flex-row mt-4 justify-center">
          <Button className="w-full" type="submit" disabled={isLoading}>
            {isLoading && <SymbolIcon className="mr-2 h-4 w-4 animate-spin" />}
            Restablecer contraseña
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default ForgotPasswordForm;
